import React, { useContext } from "react";
import SectionBlock from "../../../../global/components/FeatureCard/SectionBlock";
import personalizedExperience from "../../../../assets/images/keyAttribute/personalized-experience.png";
import scalableSystems from "../../../../assets/images/keyAttribute/scalable-systems.png";
import affordableReliability from "../../../../assets/images/keyAttribute/affordable-reliability.png";
import uiNavigation from "../../../../assets/images/keyAttribute/ui-navigation.png";
import uiIconWidget from "../../../../assets/images/keyAttribute/ui-icon-widget.png";
import uiUsersCredentials from "../../../../assets/images/keyAttribute/ui-users-credentials.png";
import uiReports from "../../../../assets/images/keyAttribute/ui-reports.png";
import uiColumns from "../../../../assets/images/keyAttribute/ui-columns.png";
import CatalogueBackground from "../../../../assets/images/download-cutsheet2.png";
import useSWR from "swr";
import DownloadSection from "../../../../lib/downloadSection";
import { fetcher } from "../../../../lib/apiConstants";
import { LoginContext } from "../../../../lib/loginContext";

const PAGE_X = "px-6 lg:px-[120px]";

const FeaturePill = ({ label }) => (
  <div className="bg-[#EAF0FF] inline-flex min-h-8 items-center max-w-full px-1 py-1 rounded-[10px]">
    <span className="text-[16px] text-[#5b5b5b] px-2 font-normal font-['Poppins'] leading-[24px] whitespace-normal lg:whitespace-nowrap">
      {label}
    </span>
  </div>
);

const splitIntoColumns = (items, columnCount = 3) =>
  Array.from({ length: columnCount }, (_, col) =>
    items.filter((_, i) => i % columnCount === col),
  );

const topFeatures = [
  {
    image: personalizedExperience,
    label: "Personalized Experience",
    description:
      "One software that is easily customized for ease of use and speed of data acquisition, Favorites, columns, search, video tutorials.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: scalableSystems,
    label: "Scalable Systems",
    description:
      "Same hardware for on premise, hybrid or cloud. Same software interface for 1 to unlimited doors and sites. Our eco system can evolve from one type of system to any other system architecture. Our software flexibility allows our hardware to morph from a server to a client allowing the administrator to have separate systems or combined into one large system and if necessary back to a independent system / hardware. Greatest flexibility in the industry every panel can be a server or a client.",
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
  },
  {
    image: affordableReliability,
    label: "Affordable Reliability",
    description:
      "Lowest cost of support with the swap board (common board that is low / fixed cost) and swap key function. The swap function allows a common board morph into any hardware function provides a low cost, minimal part replacement at a fixed cost. Database redundancy ensures integrity of the system while supporting a quick and no cost retrieval of the system data even if the server fails. Our approach provides the best approach to ensuring the system is always working at the lowest Total cost of ownership.",
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#5b5b5b",
    imageMaxWidth: "290px",
    sectionHeight: "540px",
  },
];

const uiFeatures = [
  {
    image: uiNavigation,
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
    htmlDescription: true,
    description: `<p class="mb-0"><strong>• Menu Based Navigation:</strong> Navigate the menu with ease.</p>
      <p class="mb-0"><strong>• Favorites:</strong> Configure the menu as it requires.</p>
      <p class="mb-0"><strong>• Column:</strong> Set required column to see info.</p>
      <p class="mb-0"><strong>• Active Icons:</strong> Provides status and actions via click.</p>
      <p><strong>• Help &amp; video tutorials:</strong> Learn to use the system.</p>`,
  },
  {
    image: uiIconWidget,
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
    htmlDescription: true,
    description:
      "Applications with no floor plans, <strong>Icon Widget</strong> places your system icons in a dashboard tray for easy to see item status and perform actions for each item.",
  },
  {
    image: uiUsersCredentials,
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
    htmlDescription: true,
    description: `<p class="mb-0">Adding <strong>users</strong> and <strong>credentials</strong> is easy as 1,2,3!</p>
      <p class="mb-0">• Add the User Information</p>
      <p class="mb-0">• Select an Access Level</p>
      <p>• Add a credential</p>`,
  },
  {
    image: uiReports,
    imageLeft: false,
    imageBg: "#ffffff",
    textBg: "#ffffff",
    textAlign: "right",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
    htmlDescription: true,
    description: `<p class="mb-0">Reports are simple - <strong>Who, What, Where and When</strong></p>
      <p class="mb-0">• Many predefined reports or build your own custom report.</p>
      <p>• Easy to add a filter</p>`,
  },
  {
    image: uiColumns,
    imageLeft: true,
    imageBg: "#f8f8f8",
    textBg: "#f8f8f8",
    textAlign: "left",
    bodyColor: "#3b3b3b",
    imageMaxWidth: "590px",
    sectionHeight: "540px",
    description:
      "Column feature allows you to lay out your report view and what data fields you want to see.",
  },
];

const futureReadyFeatures = [
  "20 Concurrent Users",
  "Elevator Control",
  "Event Actions - Push Notification",
  "On Premise & Cloud Management",
  "Mobile Credential - Unlimited Credentials",
  "Low Cost Service Parts - Swap Key",
  "Multi-Site Management",
  "50M On-Board Transaction Storage for Reports",
  "Hard/Soft Sequential Anti-Passback",
  "Partitioning",
  "Single-Use Credentials",
  "Occupancy",
  "Mobile App via Cloud",
  "Video View with Event Tagging",
  "Mustering",
  "On-Premises Database",
  "Multiple Credentials per User",
  "Card Reissuance",
  "Double Presentation Options Lock / Unlock",
  "Threat Level Lockdown",
  "Safety Check-In",
  "CSV Import/Export",
  "First Auto-Unlock",
  "API Integration Options",
  "Video Event Retrieval & Live View",
  "Manager-In Rule",
  "Multi-Panel System",
  "Database Redundancy*",
  "Two-Person-In Rule",
  "Dashboard Credential Enrollment",
  "Bulk Card Loader",
  "Custom Reports",
  "Credential Decoder",
];

export const KeyAttributeContent = () => {
  const { data: products, isLoading: productsLoading } = useSWR(
    "products/",
    fetcher,
  );
  const { isLoggedIn } = useContext(LoginContext);

  return (
    <div className="bg-white w-full">
      <section
        className={`bg-white flex flex-col items-center justify-center gap-6 ${PAGE_X} pt-28 sm:pt-24 min-h-[258px] text-center`}
      >
        <h1 className="text-black text-[32px] font-medium font-['Inter'] leading-normal max-w-[1174px]">
          Intelligent, Scalable & Future-Ready Access Management
        </h1>
        <p className="text-[#5b5b5b] text-[20px] font-medium font-['Poppins'] leading-normal max-w-[982px]">
          Delivering personalized user experiences, enterprise scalability, and
          reliable security operations with flexible architecture built for
          long-term growth.
        </p>
      </section>

      <div className="w-full bg-white mt-6">
        {topFeatures.map((feature) => (
          <SectionBlock key={feature.label} {...feature} />
        ))}
      </div>

      <section className={`bg-white ${PAGE_X} py-[60px]`}>
        <div className="max-w-[1184px] mx-auto flex flex-col items-center gap-9">
          <div className="flex flex-col items-center gap-4 text-center max-w-[1045px]">
            <h2 className="text-[32px] font-medium text-[#171717] font-['Inter'] leading-normal">
              Future-Ready System
            </h2>
            <p className="text-base text-[#5b5b5b] font-normal font-['Poppins'] leading-[26px] max-w-[888px]">
              Our system has many features that provide an excellent return on
              investment. Our system are generally field deployed for to plus
              years. Over the life of a system our clients requirements evolve.
              The depth of features allows the{" "}
              <span className="text-black">Sicunet</span> platform to evolve as
              your organization requirements change.
            </p>
          </div>

          <div className="flex flex-col lg:flex-row gap-8 lg:gap-[47px] w-full items-start justify-center">
            {splitIntoColumns(futureReadyFeatures).map((column, colIdx) => (
              <div
                key={colIdx}
                className="flex flex-col gap-4 items-start w-full lg:w-[387px] shrink-0"
              >
                {column.map((feature) => (
                  <FeaturePill key={feature} label={feature} />
                ))}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        className={`bg-white flex items-center justify-center min-h-[180px] ${PAGE_X} py-5`}
      >
        <h2 className="text-[32px] font-medium font-['Inter'] text-black text-center leading-normal">
          User Interface
        </h2>
      </section>

      <div className="w-full bg-white">
        {uiFeatures.map((feature, index) => (
          <SectionBlock key={index} {...feature} />
        ))}
      </div>

      {isLoggedIn && (
        <div className={` mx-auto `}>
          <DownloadSection
            backgroundColor="#FFF"
            title="Cut Sheet"
            description="Learn about Neptune 2.0 user interface & features"
            backgroundImage={CatalogueBackground}
            buttonText="Download Now"
            linkField="others_link"
            products={products || []}
            isLoading={productsLoading}
            filterBySlug="4dmpl"
            showOnlyFirst={true}
          />
        </div>
      )}
    </div>
  );
};

export default KeyAttributeContent;
